const list = [
  {
    label: 'Housing for rent',
    value: 'Housing_for_rent',
  },
  {
    label: 'Commercial property for rent',
    value: 'Commercial_property_for_rent',
  },
  {
    label: 'Plot for rent',
    value: 'Plot_for_rent',
  },
  {
    label: 'Multiple units for rent',
    value: 'Multiple_units_for_rent',
  },
];

export default list;
